var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreinamento(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-book-reader",
    "data-name": "Icon awesome-book-reader",
    d: "M17.187,4.687A4.687,4.687,0,1,0,12.5,9.375,4.687,4.687,0,0,0,17.187,4.687Zm-5.782,7.085c-2.9-1.773-7.589-2.261-9.95-2.4A1.351,1.351,0,0,0,0,10.7V21.579A1.343,1.343,0,0,0,1.293,22.9c2.132.112,6.445.521,9.426,2.023a.68.68,0,0,0,1-.58V12.332a.65.65,0,0,0-.313-.56Zm12.139-2.4c-2.361.134-7.054.622-9.95,2.4a.662.662,0,0,0-.313.568v12a.682.682,0,0,0,1,.581c2.98-1.5,7.291-1.91,9.422-2.021A1.344,1.344,0,0,0,25,21.58V10.7A1.352,1.352,0,0,0,23.544,9.377Z",
    fill: "#64c2c8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreinamento);
export default __webpack_public_path__ + "static/media/treinamento.205627bbcc49cf9304aef703bd464fb7.svg";
export { ForwardRef as ReactComponent };